import { Link } from "react-router-dom"
import { Flex, Typography } from "antd"

import { paths } from "@src/app/paths"
import css from "@src/pages/registration/index.module.css"

type Props = {
  refId: null | string
}
export const RegistrationAlreadyHas = ({ refId }: Props) => {
  return (
    <Flex align="center" gap={4}>
      <Typography.Text>Already have an account?</Typography.Text>{" "}
      <Link
        className={css.link}
        id="GENERATED_ID_REGISTRATIONALREDYHAS_LINK_LOG_IN_1"
        to={refId ? `${paths.auth}?id=${refId}` : paths.auth}
      >
        Sign in
      </Link>
    </Flex>
  )
}
